import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { TEXT_STYLES } from 'constants/text_styles'
import { NakedButton } from 'ui_elements/NakedButton/NakedButton'

const StyledText = styled.span`
  ${TEXT_STYLES.H5Black};
  color: ${props => props.theme.colors.primary};
`

const StyledNakedButton = styled(NakedButton)`
  margin-left: ${props => props.marginLeft};
`

export const StyledTextCTA = ({ text, onClick, marginLeft, title }) => {
  return (
    <StyledNakedButton
      onClick={onClick}
      marginLeft={marginLeft}
      title={title}
      role="button">
      <StyledText>{text}</StyledText>
    </StyledNakedButton>
  )
}

StyledTextCTA.defaultProps = {
  marginLeft: 'initial',
  title: undefined
}

StyledTextCTA.propTypes = {
  text: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  marginLeft: PropTypes.string,
  title: PropTypes.string
}
